import { BaseTag } from 'mixs/base/base_mixin';
import moment from 'moment';
import ResponseController from './response_controller';
import ConnectController from './connect_controller';
import ReplyController from './reply_controller';
import { AddressHashUtil } from 'utilities/address';
import { GOTO_THE_COMMENT } from 'apps/events'
class CommentsIndex extends BaseTag {
  responseController: ResponseController;
  connectController: ConnectController;
  replyController: ReplyController;
  init(){
    super.init();
    this.responseController = new ResponseController(this);
    this.connectController  = new ConnectController(this);
    this.replyController    = new ReplyController(this);
    this.listenMount([this.onMountCommentsIndex]);
    this.watch();
  }
  onMountCommentsIndex(){
    let hash = AddressHashUtil.parse()
    if(hash.comment_id == null){ return; }
    this.dispatchGotoComment(hash.comment_id);
  }
  dispatchGotoComment(comment_id){
    let customEvent = new CustomEvent(GOTO_THE_COMMENT, {detail: { target_id: comment_id } })
    document.dispatchEvent(customEvent);
  }
}

riot.mixin('comments.index', CommentsIndex as riot.TagMixin)
